import React from "react";
import styles from "./OurStory.module.css";
import officeImg from "../../assets/images/ourVerticals/AS-TOOLBOX-CC-OFFICE-1 1 (1).png";

const OurStory = () => {
  return (
    <section className={styles.storyWrapper}>
      <div className={styles.card}>
        <div className={styles.imageWrapper}>
          <img src={officeImg} alt="Office" className={styles.image} />
        </div>
        <div className={styles.textWrapper}>
          <h2 className={styles.title}>Our Story</h2>
          <p className={styles.description}>
            Cairo Capital is a premier financial institution with over two
            decades of experience, delivering comprehensive investment solutions
            across Egypt. Since 1995, it has grown into a diversified
            powerhouse, offering securities brokerage, asset management, private
            equity, and startup ventures. We invest with purpose, act with
            integrity and drive value through disciplined execution —partnering
            for long-term performance and impact.{" "}
          </p>
        </div>
      </div>
    </section>
  );
};

export default OurStory;
